import { React, useContext, useState, useCallback } from "react";
import { PeFilterContext } from "../../Contexts/PeFilterContext";
import FundSizeFilter from "../../Components/RefineSearchComponents/FundSizeFilter";
import CapitalSourceFilter from "../RefineSearchComponents/CapitalSourseFilter";
import AifCategoryFilter from "../RefineSearchComponents/AifCategoryFilter";
import FundTypeFilter from '../RefineSearchComponents/FundTypeFilter';
import FundStatusFilter from '../RefineSearchComponents/FundStatusFilter';
import FundSecondType from '../RefineSearchComponents/FundSecondType'
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { refineSearchFundStatus } from "../../Config/config";
import { UserContext } from "../../Contexts/UserContext";
import { useEffect } from "react";
import { TableDataContext } from "../../Contexts/TableDataContext";
import Constants from "../../Constants";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import Fund from "../RefineSearchComponents/Fund";
import FundInvestor from "../RefineSearchComponents/FundInvestor";

/**
 * The InvestmentRefineSearch function is a React component that renders a form for refining search
 * filters for investment data.
 * @returns The function `InvestmentRefineSearch` is returning a JSX element.
 */
export default function InvestmentRefineSearch({ customPathname }) {
    const { setrefineSearchFilters, onErrorHandler,dropdown,setMonthPickerValue ,refineSearchFilters,dbDropdown , setDbDropdown ,fundsOptions,setFundsOptions,fundInvestorsOptions,setFundInvestorsOptions  } = useContext(PeFilterContext);
    const { setCurrentPage } = useContext(TableDataContext);
    const { getToken } = useContext(UserContext);
    const [select, setSelected] = useState(0);
    const location = useLocation();
    const navigate = useNavigate();
    const { pathname } = useLocation()
    const isFromGlobalSearch = ()=> refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false
    const isFromSearchedList = ()=> refineSearchFilters[location?.state?.prevPath]?.globalSearch?.length > 0 ? true : false
    const [FundStatusOptions, setFundStatusOptions] = useState([])
    const [FundStatusSuboptions, setFundStatusSuboptions] = useState([])
    const [FundsStageOptions, setFundsStageOptions] = useState([])
    const [FundsIndustryOptions, setFundsIndustryOptions] = useState([])
    const [CapitalSourceOptions, setCapitalSourceOptions] = useState([])
    const [AifCategoryOptions, setAifCategoryOptions] = useState([])
    const [MinFundOptions, setMinFundOptions] = useState([])
    const [MaxFundOptions, setMaxFundOptions] = useState([])
    const [isSuboptionsFetch, setisSuboptionsFetch] = useState(false);

    // State for managing which filter section is active
    const [activeFilterSection, setActiveFilterSection] = useState("keyword");
    
    // State for managing which individual filter popup is open
    const [openFilterPopup, setOpenFilterPopup] = useState(null);

    // Helper functions to count applied filters for each section
    const getFundFiltersCount = () => {
        let count = 0;
        if (FundStatusOptions?.length > 0 && FundStatusOptions.some(option => option.isChecked)) count++;
        if (FundsStageOptions?.length > 0 && FundsStageOptions.some(option => option.isChecked)) count++;
        if (FundsIndustryOptions?.length > 0 && FundsIndustryOptions.some(option => option.isChecked)) count++;
        if ((MinFundOptions?.length > 0 && MinFundOptions.some(option => option.isChecked)) || (MaxFundOptions?.length > 0 && MaxFundOptions.some(option => option.isChecked))) count++;
        if (CapitalSourceOptions?.length > 0 && CapitalSourceOptions.some(option => option.isChecked)) count++;
        if (AifCategoryOptions?.length > 0 && AifCategoryOptions.some(option => option.isChecked)) count++;
        return count;
    };

    const getKeywordFiltersCount = () => {
        let count = 0;
        if (fundInvestorsOptions?.length > 0 && fundInvestorsOptions.some(option => option.isChecked)) count++;
        if (fundsOptions?.length > 0 && fundsOptions.some(option => option.isChecked)) count++;
        return count;
    };


  /**
   * The function `applyFilter` updates the refine search filters based on the selected options.
   */
    const applyFilter = () => {

        const selectedStage = FundsStageOptions?.filter(option => option.isChecked);
        const selectedIndystry = FundsIndustryOptions?.filter(option => option.isChecked);
        const selectedCpital = CapitalSourceOptions?.filter(option => option.isChecked);
        const selectedAifCategory = AifCategoryOptions?.filter(option => option.isChecked);
        const selectedFunds = fundsOptions?.filter(option => option.isChecked);
        const selectedFundInvestors = fundInvestorsOptions?.filter(option => option.isChecked);
        const invMin = MinFundOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const invMax = MaxFundOptions?.filter(option => option.isChecked)?.at(0) ?? null;
        const selectedStatus = FundStatusOptions.filter(option => option.isChecked);
        const selectedSubStatus = FundStatusSuboptions.filter(option => option.isChecked);
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {
                ...prev[customPathname],
                fundIndustry: selectedIndystry,
                fundStage: selectedStage,
                capitalSource: selectedCpital,
                aifCategory: selectedAifCategory,
                fundSize: invMin != null && invMax != null ? [invMin, invMax] : [],
                fundStatus: selectedStatus,
                closeStatus: selectedSubStatus,
                funds:selectedFunds,
                investors:selectedFundInvestors,
            },
        }))
    }

    /**
     * The function `resetFilter` resets a specific filter in the `refineSearchFilters` object by
     * setting its value to an empty object.
     */
    const resetFilter = () => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {}
        }))
    }


    // Submitting Refine Search Form 
   /**
    * The function `refineSearchFilter` updates search filters, resets the month picker value, sets the
    * current page to 1, applies the filter, deselects any selected items, and navigates to a custom
    * pathname if the current location is different.
    * @param event - The `event` parameter is an object that represents the event that triggered the
    * function. It could be an event like a button click or a form submission.
    */
    const refineSearchFilter = (event) => {
        setrefineSearchFilters(prev => ({
            ...prev,
            [customPathname]: {globalSearch:[],
            }
        }))
        if(isFromGlobalSearch() || isFromSearchedList()){
            setMonthPickerValue(Constants.initialMonthRange)
        }
        event.preventDefault();

        setCurrentPage(1);
        applyFilter();
        setSelected(false)
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
    }

 /**
  * The `onResetClick` function resets the current page, filters, and navigates to a custom pathname if
  * it is different from the current location.
  * @param event - The event parameter is an object that represents the event that triggered the
  * function. In this case, it is likely a click event on a reset button.
  */
    const onResetClick = (event) => {
        event.preventDefault();
        setCurrentPage(1);
        resetFilter()
        if (location.pathname != customPathname) {
            navigate(customPathname)
        }
        setFundInvestorsOptions([])
        setFundsOptions([])
    }

   /**
    * The function `accordionClick` sets the selected value to either 0 or the provided value.
    * @param val - The `val` parameter is a value that is passed to the `accordionClick` function. It
    * is used to determine whether the accordion should be selected or deselected.
    */
    const accordionClick = (val) => {
        if (val === select) {
            setSelected(0);
        } else {
            setSelected(val);
        }
    };

  /**
   * The function `updateSubOptions` is used to update the sub-options based on the selected option,
   * making an API call to retrieve the data and updating the state accordingly.
   * @param selected - The `selected` parameter is the value selected by the user. It represents the
   * statusId that will be used in the API request to fetch the suboptions.
   * @param initial - The `initial` parameter is a boolean value that indicates whether this function
   * is being called for the initial setup or for subsequent updates.
   * @returns The function does not explicitly return anything.
   */
    const updateSubOptions = useCallback((selected, initial) => {
        if (selected == "") {
            setFundStatusSuboptions([])
            return;
        }
        setisSuboptionsFetch(true);
        axios.post(refineSearchFundStatus, {
            "statusId": selected,
            "closeStatusId": "All"
        }, {
            headers: {
                "Authorization": getToken()
            }
        }).then((response) => {
            setisSuboptionsFetch(false);
            if (response.status === 200) {
                if (initial === true) {
                    const selectedSub = refineSearchFilters[customPathname]?.closeStatus?.map(value => value.id) ?? [];
                    setFundStatusSuboptions(response.data?.closeStatusList?.map(type => ({ ...type, isChecked: selectedSub.includes(type.id) })))
                } else {
                    setFundStatusSuboptions(response.data?.closeStatusList ?? [])
                }
            }
        }).catch((e) => {
            onErrorHandler(e)
            setisSuboptionsFetch(false);
        })
    }, [customPathname, getToken, onErrorHandler, refineSearchFilters, setFundStatusSuboptions, setisSuboptionsFetch]);

    useEffect(() => {
        const industryIds = refineSearchFilters[customPathname]?.fundStatus?.map(value => value.id) ?? [];

        if ((industryIds?.length ?? 0) != 0) {
            updateSubOptions(industryIds?.at(0), true)
        }
    }, [customPathname, refineSearchFilters, updateSubOptions])

    const handleDbToggle = () => {
        setDbDropdown(!dbDropdown);
    };

    return (
        <div className="bg-white">
            <div className="h-full no-scrollbar">
                <form onSubmit={refineSearchFilter} onReset={onResetClick} className="h-full w-full">
                    <main className="h-full w-full py-4">
                        <div className="flex flex-col md:grid md:grid-cols-8 gap-2 md:gap-4 h-full">
                            {/* Left column - Headers */}
                            <div className="flex flex-row md:flex-col gap-1 md:gap-2 border-b md:border-b-0 md:border-r border-gray-300 pb-2 md:pb-0 md:pr-4 md:max-w-[320px] md:col-span-2 items-baseline md:items-stretch overflow-x-auto flex-wrap md:flex-nowrap">
                                <div 
                                    className={`cursor-pointer p-2 lg:p-3 rounded-lg transition-colors whitespace-nowrap ${
                                        activeFilterSection === 'keyword' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'keyword' ? null : 'keyword')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 lg:gap-2">
                                            <span className="text-sm lg:text-base font-medium">Keyword Search</span>
                                            {getKeywordFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-1 lg:px-2 py-0.5 lg:py-1 min-w-[18px] lg:min-w-[20px] text-center ${activeFilterSection === 'keyword' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getKeywordFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'keyword' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>
                                <div 
                                    className={`cursor-pointer p-2 lg:p-3 rounded-lg transition-colors whitespace-nowrap ${
                                        activeFilterSection === 'fund' ? 'bg-[#BC8B20] text-white' : 'hover:bg-gray-100'
                                    }`}
                                    onClick={() => setActiveFilterSection(activeFilterSection === 'fund' ? null : 'fund')}
                                >
                                    <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-1 lg:gap-2">
                                            <span className="text-sm lg:text-base font-medium">Fund</span>
                                            {getFundFiltersCount() > 0 && (
                                                <span className={`text-xs rounded-full px-1 lg:px-2 py-0.5 lg:py-1 min-w-[18px] lg:min-w-[20px] text-center ${activeFilterSection === 'fund' ? 'bg-white text-[#bc8b20]' : 'bg-[#bc8b20] text-white'}`}>
                                                    {getFundFiltersCount()}
                                                </span>
                                            )}
                                        </div>
                                        {activeFilterSection === 'fund' ? <IoMdArrowDropdown /> : <IoMdArrowDropright />}
                                    </div>
                                </div>
                            </div>
                            
                            {/* Right column - Filters */}
                            <div className="overflow-visible mt-4 md:mt-0 pb-20 md:pb-0 md:col-span-6">
                                <div className={`w-full lg:w-2/4 ${activeFilterSection === 'keyword' ? '' : 'hidden'}`}>
                                    <div className="space-y-4">
                                        <FundInvestor 
                                            options={fundInvestorsOptions}
                                            setOptions={setFundInvestorsOptions}
                                            customPathname={customPathname}
                                            label="Investors"
                                            accordionClick={() => accordionClick(3)}
                                            open={select === 3}
                                        />
                                        <Fund 
                                            options={fundsOptions}
                                            setOptions={setFundsOptions}
                                            customPathname={customPathname}
                                            label="Funds"
                                            accordionClick={() => accordionClick(1)}
                                            open={select === 1}
                                        />
                                    </div>
                                </div>
                                
                                <div className={`grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-8 ${activeFilterSection === 'fund' ? '' : 'hidden'}`}>
                                    <FundStatusFilter
                                        FundStatusOptions={FundStatusOptions}
                                        setFundStatusOptions={setFundStatusOptions}
                                        FundStatusSuboptions={FundStatusSuboptions}
                                        setFundStatusSuboptions={setFundStatusSuboptions}
                                        customPathname={customPathname}
                                        accordionClick={() => accordionClick(24)}
                                        updateSubOptions={updateSubOptions}
                                        isSuboptionsFetch={isSuboptionsFetch}
                                        open={select === 24}
                                        isPopupOpen={openFilterPopup === 'fundStatus'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'fundStatus' : null)}
                                    />
                                    <FundTypeFilter
                                        FundsStageOptions={FundsStageOptions}
                                        setFundsStageOptions={setFundsStageOptions}
                                        customPathname={customPathname}
                                        accordionClick={() => accordionClick(22)}
                                        open={select === 22}
                                        isPopupOpen={openFilterPopup === 'fundType'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'fundType' : null)}
                                        label="Fund Type"
                                    />
                                    <FundSecondType
                                        FundsIndustryOptions={FundsIndustryOptions}
                                        setFundsIndustryOptions={setFundsIndustryOptions}
                                        customPathname={customPathname}
                                        accordionClick={() => accordionClick(25)}
                                        open={select === 25}
                                        isPopupOpen={openFilterPopup === 'fundSecondType'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'fundSecondType' : null)}
                                    />
                                    <FundSizeFilter
                                        MinFundOptions={MinFundOptions}
                                        setMinFundOptions={setMinFundOptions}
                                        MaxFundOptions={MaxFundOptions}
                                        setMaxFundOptions={setMaxFundOptions}
                                        customPathname={customPathname}
                                        isPopupOpen={openFilterPopup === 'fundSize'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'fundSize' : null)}
                                    />
                                    <CapitalSourceFilter
                                        CapitalSourceOptions={CapitalSourceOptions}
                                        setCapitalSourceOptions={setCapitalSourceOptions}
                                        customPathname={customPathname}
                                        accordionClick={() => accordionClick(21)}
                                        open={select === 21}
                                        isPopupOpen={openFilterPopup === 'capitalSource'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'capitalSource' : null)}
                                    />
                                    <AifCategoryFilter
                                        AifCategoryOptions={AifCategoryOptions}
                                        setAifCategoryOptions={setAifCategoryOptions}
                                        customPathname={customPathname}
                                        isPopupOpen={openFilterPopup === 'aifCategory'}
                                        setIsPopupOpen={(isOpen) => setOpenFilterPopup(isOpen ? 'aifCategory' : null)}
                                    />
                                </div>
                                
                                <div className={`flex items-center justify-center h-40 text-gray-500 ${activeFilterSection ? 'hidden' : ''}`}>
                                    <p>Select a filter category from the left to view available filters</p>
                                </div>
                            </div>
                        </div>
                    </main>
                </form>
            </div>
        </div>
    );
}
